import { viewJobNativeModule } from './ViewJobNativeModule';
import { callPromiseAssert } from '../../shared/util/callPromiseAssert';

export function httpPostJson<T>(url: string, payload: string): Promise<T> {
    return callPromiseAssert(viewJobNativeModule()?.httpPostJson<T>, 'httpPostJson', url, payload);
}
